import { 
    GET_SERVER,
    GET_VERSION,
    GET_IP,
    SET_SERVER_VERSION
  } from './types';

import axios from 'axios';
import { getApiUrl } from '../util/getServerInfo';

export const getServer = () => {

    return async(dispatch) => {
        const reqBody = {   
            "jsonrpc": 2.0,
            "method": "config.meta.getStartup",
            "id": 200
        };

        await axios({
            method: 'post',
            url: getApiUrl(),
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: reqBody,
            timeout: 6000
        })
        .then( response => {
            const data = response.data.result[1];
            let general =  data[Object.keys(data)[0]];
            // Use fEview property directly (consistent with LoginView fetchConnectedServers)
            // Fallback to rgsFeature check for older server versions
            let eview = general.fEview || (general.rgsFeature && general.rgsFeature.includes('eview')) || false;
            let authServers = data[Object.keys(data)[1]];
            let usersOnline = data[Object.keys(data)[2]]
            let sApiToken = authServers && authServers[0] ? authServers[0].sApiToken : '' ;

            dispatch({
                type: GET_SERVER,
                bSerial: general.bSerial,
                sName: general.sName,
                sVersion: general.sVersion || '',
                sReleaseVersion: general.sReleaseVersion || '',
                fReleaseCandidate: !!general.fReleaseCandidate,
                sApiToken: sApiToken,
                bNumcams: general.bNumcams,
                fEview: eview,
                authServers, // an array of objects with properties: { bPort, bRtspPort, bSerial, bTimestamp, fLocal, sIP, sLocalIP, sName, sVersion }
                usersOnline // an array of users online [ 'username', 'username' ]
            })
        })
        .catch(error => {
            console.error('Error:', error);
        }); 
    };
}; 

/**
 * Re-read the serving NVR's DVS version for a tab left open across an upgrade.
 *
 * getServer runs only on load, and the session survives an NVR upgrade, so the
 * version in StatusView and the system info sheet stayed on the old release
 * until a refresh. This reads the same getStartup answer but applies only the
 * version fields, and only when they changed for the server already shown, so
 * the poll does not re-render the grid or race a jump to another NVR.
 */
export const refreshServerVersion = () => {
    return async(dispatch, getState) => {
        try {
            const response = await axios({
                method: 'post',
                url: getApiUrl(),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                data: { "jsonrpc": 2.0, "method": "config.meta.getStartup", "id": 200 },
                timeout: 6000
            });
            const data = response.data.result[1];
            const general = data[Object.keys(data)[0]];
            const server = getState().server;
            if (!general || general.bSerial !== server.bSerial) return;
            const sVersion = general.sVersion || '';
            const sReleaseVersion = general.sReleaseVersion || '';
            const fReleaseCandidate = !!general.fReleaseCandidate;
            if (sVersion === server.sVersion && sReleaseVersion === server.sReleaseVersion
                && fReleaseCandidate === !!server.fReleaseCandidate) return;
            dispatch({ type: SET_SERVER_VERSION, sVersion, sReleaseVersion, fReleaseCandidate });
        } catch (error) {
            // Unreachable mid-upgrade: keep the version shown; the next poll retries.
        }
    };
};

export const getVersion = ( session, server ) => {
    return (dispatch) => {
        // make an axios request to json-rpc
        dispatch({ type: GET_VERSION })
    };
};
    
export const getIp = ( session, server ) => {
    return (dispatch) => {
        // make an axios request to json-rpc
        dispatch({ type: GET_IP })
    };
};
  
export const isAlive = () => {
    return async( dispatch ) => {
        const reqBody = {   "jsonrpc": 2.0,
                            "method": "info.isAlive",
                            "id": 200
                        };
        await axios({
            method: 'post',
            url: getApiUrl(),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: reqBody,
            timeout: 2000
        })
        .then( response => {
   
            const data = response.data.result[1]
        
            if(!data) {
                return false;
            }
            return true;
        })
        .catch(error => {
            console.error('Error:', error);
            return false;
        }); 
    };
};
